export const LINK_MARKDOWN_INPUT_REGEX =
  /(?:^|\s)\[([^\]]*)?\]\((\S+)(?: ["“](.+)["”])?\)$/i;
